import axios from "axios";
import * as url from "../utils/urls";
// eslint-disable-next-line
export default {
  login: payload => {
    return axios.post(url.loginUrl, payload);
  },
  emailVerification: payload => {
    return axios.post(url.emailVerificationUrl, payload);
  },
  verifyEmail: payload => {
    return axios.post(url.verifyEmailUrl, payload);
  },
  signUp: payload => {
    return axios.post(url.signUpUrl, payload);
  },
  forgotPasswordRequest: payload => {
    return axios.post(url.forgotPasswordRequestUrl, payload);
  },
  confirmPasswordRequest: payload => {
    return axios.patch(url.confirmPasswordRequestUrl, payload);
  },
  getSpecialityList: () => {
    return axios.get(url.getSpecialityListUrl);
  },
  getLanguageList: () => {
    return axios.get(url.getLanguageListUrl);
  },
  getEducationalList: () => {
    return axios.get(url.getDegreeListUrl);
  },
  getNotifications: () => {
    return axios.get(url.getNotificationsUrl);
  },
  saveDoctorDetails: payload => {
    return axios.post(url.saveDoctorDetailsUrl, payload);
  },
  addDoctorAppTheme: payload => {
    return axios.post(url.addDoctorAppThemeUrl, payload);
  },
  getAppointmentList: (page, payload) => {
    return axios.post(url.getAppointmentListUrl(page), payload);
  },
  updateAppointmentStatus: (appointmentId, payload) => {
    return axios.patch(url.updateAppointmentStatusUrl(appointmentId), payload);
  },
  getAppointmentDetail: appointmentId => {
    return axios.get(url.getAppointmentDetailUrl(appointmentId));
  },
  getDoctorPatientList: (doctorDetailId, page,q) => {
    return axios.get(url.getDoctorPatientListUrl(doctorDetailId, page,q));
  },
  updateNudgePermission: (id, payload) => {
    return axios.patch(url.updateNudgePermissionUrl(id), payload);
  },
  getNudgePermission: id => {
    return axios.get(url.getNudgePermissionUrl(id));
  },
  clearNotifications: () => {
    return axios.delete(url.clearNotificationsUrl());
  },
  markAsRead: () => {
    return axios.get(url.markAsReadUrl());
  },
  deletePatientPCPDoctor: pcpId => {
    return axios.delete(url.deletePatientPCPDoctorUrl(pcpId));
  },
  getPaitentInfo: Id => {
    return axios.get(url.getPatientDetailsUrl(Id));
  },
  updateUserInfo: (user, payload) => {
    return axios.patch(url.updateUserUrl(user), payload);
  },
  savePaitentInfo: payload => {
    return axios.post(url.savePatientDetailsUrl, payload);
  },
  updateUserImage: (user, payload) => {
    return axios.patch(url.updateProfileImageUrl(user), payload);
  },
  updatePatientDetails: (Id, payload) => {
    return axios.patch(url.updatePatientDetailUrl(Id), payload);
  },
  updatePatientMedicalRecord: (Id, payload) => {
    return axios.patch(url.updatePatientMedicalRecordsUrl(Id), payload);
  },
  savePatientMedicalRecord: payload => {
    return axios.post(url.savePatientMedicalRecordsUrl, payload);
  },
  savePatientContactDetail: (Id, payload) => {
    return axios.patch(url.savePatientContactDetailUrl(Id), payload);
  },
  addNoteTemplate: payload => {
    return axios.post(url.addNoteTemplateUrl, payload);
  },
  getAllNoteTemplate: (q, page) => {
    return axios.get(url.getAllNoteTemplateUrl(q, page));
  },
  editNoteTemplate: (tempID, payload) => {
    return axios.patch(url.editNoteTemplateUrl(tempID), payload);
  },
  deleteNoteTemplate: tempID => {
    return axios.delete(url.delteNotebyId(tempID));
  },
  searchNoteTemplates: q => {
    return axios.get(url.searchNotes(q));
  },
  addNotesLock: payload => {
    return axios.post(url.addNotesUrl(), payload);
  },
  appointmentSessionCreation: payload => {
    return axios.post(url.appointmentSessionCreationUrl(), payload);
  },
  getDateWiseAppointmentList: (page, payload) => {
    return axios.post(url.getDateWiseAppointmentListUrl(page), payload);
  },
  patientNotesGet: (id, q, page) => {
    return axios.post(url.getPatientNotes(q, page), { patient: id });
  },
  patientNotesUpdate: (id, payload) => {
    return axios.patch(url.updatePatientNotes(id), payload);
  },
  patientNoteDelete: id => {
    return axios.delete(url.deletePatientNotes(id));
  },
  patientNoteAdd: payload => {
    return axios.post(url.addPatientNotes, payload);
  },
  blockedPatientList: (page, payload) => {
    return axios.post(url.getBlockedPatients(page), payload);
  },
  blockPatient: payload => {
    return axios.post(url.blockPatientUrl, payload);
  },
  unblockPatient: id => {
    return axios.delete(url.unblockPatientUrl(id));
  },
  searchPhysicians: (q, page, payload) => {
    return axios.post(url.searchPhysicians(q, page), payload);
  },
  updateAvailablePermission: (id, payload) => {
    return axios.patch(url.updateAvailablePermissionUrl(id), payload);
  },
  getAvailablePermission: id => {
    return axios.get(url.getAvailablePermissionUrl(id));
  },
  addVisitNowRequest: payload => {
    return axios.post(url.addVisitNowRequestUrl(), payload);
  },
  getVisitNowRequest: appointmentId => {
    return axios.get(url.getVisitNowRequestUrl(appointmentId));
  },
  updateVisitNowRequestStatus: (appointmentId, payload) => {
    return axios.patch(
      url.updateVisitNowRequestStatusUrl(appointmentId),
      payload
    );
  },
  getCurrentPhysician: () => {
    return axios.get(url.getCurrentPhysicianUrl);
  },
  addUserLocation: payload => {
    return axios.post(url.addUserLocationUrl, payload);
  },
  updateUserLocation: (userId, payload) => {
    return axios.patch(url.updateUserLocationUrl(userId), payload);
  },
  getUserLocation: () => {
    return axios.get(url.getUserLocationUrl);
  },
  updateDrLocationStatus: (id, payload) => {
    return axios.patch(url.updateDrLocationStatusUrl(id), payload);
  },
  updateGuestDoctorRequest: (appointmentId, payload) => {
    return axios.patch(url.updateGuestDoctorRequestUrl(appointmentId), payload);
  },
  getSessionDetailsForPatient: payload => {
    return axios.post(url.getSessionDetailsForPatientUrl(), payload);
  },
  addGuestDoctor: (appointmentId, payload) => {
    return axios.patch(url.addGuestDoctorUrl(appointmentId), payload);
  },
  removeGuestDoctorRequest: appointmentId => {
    return axios.patch(url.removeGuestDoctorRequestUrl(appointmentId));
  },
  getPatientFiles: (q, page, payload) => {
    return axios.post(url.getPatientFilesUrl(q, page), payload);
  },
  addPatientChatAttachment: payload => {
    return axios.post(url.addPatientChatAttachmentUrl(), payload);
  },
  getBankDetailsForPhysician: doctorId => {
    return axios.post(url.getBankDetailsForPhysicianUrl(doctorId));
  },
  addBankDetailsForPhysician: payload => {
    return axios.post(url.addBankDetailsForPhysicianUrl(), payload);
  },
  updateAppointmentCompletedStatus: (appointmentId, payload) => {
    return axios.patch(
      url.updateAppointmentCompletedStatusUrl(appointmentId),
      payload
    );
  },
  updateUserRole: (id, payload) => {
    return axios.patch(url.updateUserRoleUrl(id), payload);
  },
  updateVisitNowRequest: (id, payload) => {
    return axios.patch(url.updateVisitNowRequestUrl(id), payload);
  },
  getUserDetailId: payload => {
    return axios.post(url.getUserDetailIdUrl, payload);
  },
  updateBankDetailsForPhysician: payload => {
    return axios.post(url.updateBankDetailsForPhysicianUrl(), payload);
  },
  addCardDetailsForPhysician: payload => {
    return axios.post(url.addCardDetailsForPhysicianUrl(), payload);
  },
  getCustomerCardDetails: id => {
    return axios.post(url.getCustomerCardDetailsUrl(id));
  },
  deleteUserCardDetails: id => {
    return axios.delete(url.deleteUserCardDetailsUrl(id));
  },
  getSubscriptionPlanListForPhysician: () => {
    return axios.get(url.getSubscriptionPlanListForPhysicianUrl());
  },
  addSubscriptionPlanForPhysician: payload => {
    return axios.post(url.addSubscriptionPlanForPhysicianUrl(), payload);
  },
  updatePhysicianStatus: (id, payload) => {
    return axios.patch(url.updateDoctorStatus(id), payload);
  },
  getPatientVitals: payload => {
    return axios.post(url.getPatientVitalsUrl(), payload);
  },
  attachPaymentMethod: payload => {
    return axios.post(url.attachPaymentMethodUrl(), payload);
  },
  addACHBankDetails: payload => {
    return axios.post(url.addACHBankDetailsUrl(), payload);
  },
  payPersonlizedExperience: payload => {
    return axios.post(url.oneTimePaymentUrl(), payload);
  },
  getCustomerBankDetails: id => {
    return axios.get(url.getCustomerBankDetailsUrl(id));
  },
  deleteACHBankDetails: bankId => {
    return axios.delete(url.deleteACHBankDetailsUrl(bankId));
  },
  getCustomerPaymentHistory: (id, payload) => {
    return axios.post(url.getCustomerPaymentHistoryUrl(id), payload);
  },
  downloadInvoice: payload => {
    return axios.post(url.downloadInvoiceUrl(), payload);
  },
  getAllPatientList: (id, page, q) => {
    return axios.get(url.getAllPatientListUrl(id, page, q));
  },
  cancelSubscription: payload => {
    return axios.post(url.cancelSubscriptionUrl(), payload);
  },
  getSubscriptionDetail: payload => {
    return axios.post(url.getSubscriptionDetailUrl(), payload);
  },
  setupIntent: () => {
    return axios.post(url.setupIntentUrl());
  },
  getPaymentDetails: (q, page, payload) => {
    return axios.post(url.getPaymentDetailsUrl(q, page), payload);
  },
  placeHoldOnCard: payload => {
    return axios.post(url.placeHoldOnCardUrl(), payload);
  },
  captureHoldAmount: payload => {
    return axios.post(url.captureHoldAmountURL(), payload);
  },
  reviewChartNotification: visit_now_id => {
    return axios.get(url.reviewChartNotificationUrl(visit_now_id));
  },
  getSSOURL: payload => {
    return axios.post(url.getSSOURL(), payload);
  },
  addDoctorDoseSpotID: (physicianId, payload) => {
    return axios.patch(url.addDoctorDoseSpotIDURL(physicianId), payload);
  },
  getDoctorByDoseSpotID: payload => {
    return axios.post(url.getDoctorByDoseSpotIDURL(), payload);
  },
  updateDoctorPaidDetails: doctorDetailId => {
    return axios.patch(url.updateDoctorPaidDetailsURL(doctorDetailId));
  },
  addPatientDoseSpotID: (patientId, payload) => {
    return axios.patch(url.addPatientDoseSpotIDURL(patientId), payload);
  },
  getChatDetails: chatId => {
    return axios.get(url.getChatDetailsUrl(chatId));
  },
  updateChatDetail: (chatId, payload) => {
    return axios.patch(url.updateChatDetailUrl(chatId), payload);
  },
  signOut:(param) => {
    return axios.post(`${url.signOutUrl}?refresh_token=${param?.refresh_token}&fcm_id=${param?.fcm_token}`);
  },
  scheduleRunner: () => {
    return axios.get(url.scheduleRunnerUrl());
  },
};
